import { Routes } from '@angular/router';
import { ConsumerLayoutComponent } from './core/layout/consumer-layout.component';
import { passengerAuthGuard } from './core/guards/passenger-auth.guard';
import { BookingConfirmedPage } from './features/booking/presentation/booking-confirmed.page';
import { CheckoutPage } from './features/booking/presentation/checkout.page';

export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () =>
      import('./features/auth/presentation/auth.page').then((m) => m.AuthPage),
  },
  {
    path: '',
    component: ConsumerLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/home/presentation/home.page').then((m) => m.HomePage),
      },
      {
        path: 'search',
        loadComponent: () =>
          import('./features/booking/presentation/search.page').then((m) => m.SearchPage),
      },
      {
        path: 'select-seats',
        loadComponent: () =>
          import('./features/booking/presentation/select-seats.page').then(
            (m) => m.SelectSeatsPage,
          ),
      },
      {
        path: 'checkout',
        component: CheckoutPage,
      },
      {
        path: 'booking-confirmed',
        component: BookingConfirmedPage,
      },
      {
        path: 'my-trips',
        canActivate: [passengerAuthGuard],
        loadComponent: () =>
          import('./features/trips/presentation/my-trips.page').then((m) => m.MyTripsPage),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
